import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ResetService } from './reset.service';

@Injectable()
export class ResetGuardService {
	constructor(
		private readonly resetPassword: ResetService,
		private readonly router: Router
	) {}

	canActivate(route: ActivatedRouteSnapshot): boolean {
		if (route.queryParams.key) {
			this.resetPassword.token = route.queryParams.key;
			return true;
		}

		this.router.navigate(['']).then();
		return false;
	}
}

export const ResetGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean =>
	inject(ResetGuardService).canActivate(route);
